import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const ListFilesEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.loadFiles.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return OrderRepository.getFiles(action.payload.orderId).pipe(
        mergeMap((response) => of(order.loadFilesSuccess({ orderId: action.payload.orderId, fileList: response }))),
        catchError((error: Error) => {
          return of(order.loadFilesError({ orderId: action.payload.orderId, error }))
        })
      )
    })
  )
